import { Link } from 'react-router-dom';
import { MapPin, Bed, Bath, Square, Ruler, Eye } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export function PropertyCard({ property, index = 0 }) {
  const mainImage = property.images && property.images.length > 0
    ? `${API}/files/${property.images[0]}?size=thumb&v=3`
    : 'https://images.unsplash.com/photo-1706808849827-7366c098b317?w=800';

  const formatPrice = (price) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <Link
      to={`/properties/${property.id}`}
      className="property-card group block opacity-0 animate-fadeIn"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`property-card-${property.id}`}
    >
      {/* Image */}
      <div className="relative overflow-hidden rounded-xl aspect-[4/3] mb-4 shadow-md group-hover:shadow-xl transition-shadow duration-300">
        <img
          src={mainImage}
          alt={property.title}
          className="property-card-image w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-4 left-4">
          <span className="bg-primary text-white px-3 py-1 rounded-md text-xs font-sans font-medium uppercase">
            {property.contract_type === 'vendita' ? 'In Vendita' : 'In Affitto'}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <span className="bg-white/90 text-text-main px-3 py-1 rounded-md text-xs font-sans font-medium">
            {property.property_type}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="space-y-2">
        <p className="font-serif text-2xl text-primary font-semibold">
          {formatPrice(property.price)}
        </p>
        <h3 className="font-serif text-xl text-text-main group-hover:text-primary transition-colors line-clamp-1">
          {property.title}
        </h3>
        <div className="flex items-center text-text-muted">
          <MapPin size={14} className="mr-1" />
          <span className="font-sans text-sm">{property.city}, {property.address}</span>
        </div>

        {/* Features */}
        <div className="flex items-center flex-wrap gap-3 pt-2">
          {property.rooms && (
            <div className="flex items-center text-text-muted">
              <Bed size={16} className="mr-1" />
              <span className="font-sans text-sm">{property.rooms}</span>
            </div>
          )}
          {property.bathrooms && (
            <div className="flex items-center text-text-muted">
              <Bath size={16} className="mr-1" />
              <span className="font-sans text-sm">{property.bathrooms}</span>
            </div>
          )}
          <div className="flex items-center text-text-muted">
            <Square size={16} className="mr-1" />
            <span className="font-sans text-sm">{property.area_sqm} m²</span>
          </div>
          {property.external_area_sqm && (
            <div className="flex items-center text-text-muted">
              <Ruler size={16} className="mr-1" />
              <span className="font-sans text-sm">{property.external_area_sqm} m² est.</span>
            </div>
          )}
          <div className="flex items-center text-text-muted ml-auto">
            <Eye size={15} className="mr-1" />
            <span className="font-sans text-xs">{property.views || 0}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
